// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"54":"2dbd38df1217ec6c","405":"8afdd040a349df3b","503":"3fe97787e9bafc50","668":"c596ec2e1b607d49","696":"4ecf317cf4f9a6ed","888":"6d82b218a8b1b06b"}[chunkId] + ".css";
};